const normalizeLanguage = (language) => (language || "").toLowerCase();

const buildPrefix = (breakpoint) => (breakpoint ? `tw:${breakpoint}:` : "tw:");

const composeClass = (variant, value, important) =>
  `${variant}${important ? "!" : ""}${value}`;

export const getTypographyClass = (language, size, breakpoint, options = {}) => {
  const { important = false } = options;
  const isJapanese = ["jp", "ja"].includes(normalizeLanguage(language));
  const prefix = buildPrefix(breakpoint);

  switch (size) {
    case 14:
      return `${composeClass(prefix, "!text-[15px]", important)} ${composeClass(
        prefix,
        `leading-[${isJapanese ? "24px" : "22px"}]`,
        important
      )}`;
    case 13:
      return `${composeClass(prefix, "text-[14px]", important)} ${composeClass(
        prefix,
        `leading-[${isJapanese ? "22px" : "20px"}]`,
        important
      )}`;
    case 12:
      return isJapanese
        ? composeClass(prefix, "text-[13px]", important)
        : `${composeClass(prefix, "text-[13px]", important)} ${composeClass(
          prefix,
          "leading-[18.5px]",
          important
        )}`;
    case 10:
      return isJapanese
        ? composeClass(prefix, "text-[10px]", important)
        : `${composeClass(prefix, "text-[10px]", important)} ${composeClass(
          prefix,
          important
        )}`;

    default:
      return "";
  }
};

export const createTypographyHelper = (language) =>
  (size, breakpoint, options) => getTypographyClass(language, size, breakpoint, options);
